// extracted by mini-css-extract-plugin
export default {"divider":"sIKHdcbZ8UTGD9If8EM9","dividerVertical":"uPkxbvryJiwB2EJvagx4"};